import React, { useEffect } from "react";
import "./App.css";
import Header from "./Header";
import Home from "./Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Checkout from "./Checkout";
import Login from "./Login";
import Payment from './Payment';
import Orders from "./Orders";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const promise = loadStripe('pk_test_51Hzi0MAk7febpT0famR5kekRCFlYa1Ksp1SSQWs66UjeNnkrvEzSRsMPEhSI3lhI88XwJ72PnrtTBU5Nc2kfP7rp00zHDbwHUt');

function App() {  
  const [{}, dispatch] = useStateValue();


  // This following auth and  else lines of code do all the hard work for user to sign in
  useEffect(() => {
    //This will run only once when the app component loads...
    auth.onAuthStateChanged(authUser => {
      console.log('THE USER IS >>> ', authUser);

      if (authUser) {
        // the user just logged in / The user was logged in

        dispatch({
          type: 'SET_USER',
          user: authUser
        })
      } else {
        //The user is logged out
        dispatch({
          type: 'SET_USER',
          user: null
        })
      }
    })

  }, [])


  return (
    // BEM
    <Router>
    <div className="app">
      <Switch>
      <Route path="/orders">
        <Header />
        <Orders />
        </Route>
       <Route path="/login">
        <Login />
      </Route>
      <Route path="/checkout">
        <Header />
      <Checkout />
      </Route>
      <Route path="/payment">
        <Header />
        <Elements stripe={promise}>
        <Payment />
        </Elements> 
      </Route>
      <Route path="/">
        <Header />
      <Home />
    </Route>
    </Switch> 
    </div>
    </Router>
  );
}

export default App;


//Repeat the same process on how to do multiple pages. This case is about checkout. 
//Note: In order for this to work we need to keep the Route, Header, Home, Route (The Home Part) for last. Otherwise, it won't work 